import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { CallCenterApplicationModel } from 'src/app/model/CallCenterApplicationModel';
import { PaymentReconciliationService } from 'src/app/services/payment-reconciliation.service';

@Component({
  selector: 'app-secure-call-center-transaction-modal',
  templateUrl: './transaction-modal.component.html',
  styleUrls: ['./transaction-modal.component.scss']
})
export class CallCenterTransactionModalComponent implements OnInit {
  viewApplicationTransactions: CallCenterApplicationModel;

  constructor(private modalCtrl: ModalController, 
    private paymentReconciliationService: PaymentReconciliationService, private router: Router) { }

  ngOnInit(): void { }

  onCheckTransactionStatus(transactionId: string) {
    this.paymentReconciliationService.fetchPaymentReconciliationByTransactionId(transactionId)
    .subscribe(async (obj) => {
      if(obj) {
        if(obj.paymentStatus === 'PENDING') {
          this.paymentReconciliationService.errorToast("Transaction status is Pending");
        }
        else if(obj.paymentStatus === 'SUCCESS') {
          this.paymentReconciliationService.successToast("Transaction status is Success");
          let selectedTransaction = this.viewApplicationTransactions.transactionList.find(t => t.transactionId === transactionId);
          selectedTransaction.paymentStatus = obj.paymentStatus;
          this.modalCtrl.dismiss(null, 'close');
          this.router.navigate(['/secure', 'call-center', this.viewApplicationTransactions.registrationId, 
          this.viewApplicationTransactions.applicationId]);
        }
        else if(obj.paymentStatus === 'FAILURE') {
          this.paymentReconciliationService.errorToast("Transaction status is Failure");
          let selectedTransaction = this.viewApplicationTransactions.transactionList.find(t => t.transactionId === transactionId);
          selectedTransaction.paymentStatus = obj.paymentStatus;
          this.modalCtrl.dismiss(null, 'close');
          this.router.navigate(['/secure', 'call-center', this.viewApplicationTransactions.registrationId, 
          this.viewApplicationTransactions.applicationId]);
        }
      }
      else {
        this.paymentReconciliationService.errorToast("Please try again");
      }
    });
  }

  onCancel() {
    return this.modalCtrl.dismiss(null, 'close');
  }

}
